import * as React from 'react';
import { useEffect, useState } from 'react';
import { useUserStore } from 'src/hooks/admin/user';
import { useAdminCommonStore } from 'src/hooks/admin/adminCommon';
import Helper from 'src/support/Helper';
import useReduxState from 'src/hooks/useReduxState';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import Constants from 'src/support/Constants'
import { useAdminAccountFilterStore } from 'src/hooks/admin/adminAccountFilter';
import { Tooltip } from 'src/component/Tooltip';


const UserSearchAcct = (props) => {

    const [{ orgList }, { get_organization_detail }, { }] = useAdminCommonStore();
    const [{ }, { }, { set_search_acct_list, }] = useUserStore();
    const defaultModel = { accountName: "", accountNumber: "", speedboat: [], salesOrg: [] };
    const [searchData, setSearchData] = useState(defaultModel);
    const [{ filter_list }, { }, { clear_all_filter, set_filter_list }] = useAdminAccountFilterStore();
    const [errAlert, setErrAlert] = useReduxState("", 'setErrAlert');
    const [disableSearch, setDisableSearch] = useReduxState(true, 'setDisableAccountSearch');
    const [minTwoErr, setMinTwoErr] = useState(false);
    const [detailValidation, setDetailValidation] = useState({})


    const keyMap = {
        accountName: "Account Name",
        accountNumber: "Account Number",
        speedboat: "Speedboat",
        salesOrg: "Sales Org"
    }

    useEffect(() => {
        async function fetchHere() {
            get_organization_detail();
        }
        fetchHere();
    }, []);

    useEffect(() => {
        if (!filter_list || Object.entries(filter_list).length === 0) {
            setSearchData(defaultModel)
        } else {
            let searchingData = defaultModel
            searchingData.accountName = filter_list?.accountName?.searchKeyword || ''
            searchingData.accountNumber = filter_list?.accountNumber?.searchKeyword || ''
            searchingData.speedboat = filter_list?.speedboat?.searchKeywordArr ? filter_list?.speedboat?.searchKeywordArr : [];
            searchingData.salesOrg = filter_list?.salesOrg?.searchKeywordArr ? filter_list?.salesOrg?.searchKeywordArr : [];
            setSearchData(searchingData)
        }
    }, [filter_list]);

    const onSearch = (e) => {
        e.preventDefault();
        const isSearchDataEmpty = Object.values(searchData).every(value => !value);

        if (isSearchDataEmpty) {
            setErrAlert('At least one of the field from Account Number or Account Name should have search keywords to display results', 'danger', 'search')
            return;
        }

        const filterList = Object.entries(searchData)
            .filter(([key, value]) => Helper.valueIsNotNull(value)).map((v) => {
                const val = {
                    searchType: keyMap[v[0]],
                    key: v[0],
                    [Array.isArray(v[1]) ? 'searchKeywordArr' : 'searchKeyword']: v[1],
                }
                return val;
            });
        const filterListObject = filterList?.reduce((acc, curr) => {
            acc[curr.key] = curr;
            return acc;
        }, {});

        if (filterList.length === 0) {
            setErrAlert('Enter at least 2 characters without zero', 'danger', 'search');
            return;
        }

        // Clear Alert
        setErrAlert('');
        set_filter_list(filterListObject);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSearchData({
            ...searchData,
            [name]: value,
        });
    };

    useEffect(() => {
        if ((searchData.accountNumber?.trim()?.length === 1) || (searchData.accountName?.trim()?.length === 1)) {
            setDisableSearch(true);
            return;
        }
        if (searchData.accountNumber?.length === 0 && searchData.accountName?.length === 0) {
            setDisableSearch(true);
            return;
        }
        if (searchData.speedboat?.length > 0 && (searchData.accountNumber?.length > 0 || searchData.accountName?.length > 0)) {
            if (searchData.accountNumber?.length > 0 && (!/^(?!0+$)[0-9]+$/.test(searchData.accountNumber))) {
                setDisableSearch(true);
                return;
            }
            setDisableSearch(false);
            return;
        }
        setDisableSearch(true);
    }, [searchData]);

    const onClear = async () => {
        set_search_acct_list();
        setSearchData(defaultModel)
        setMinTwoErr(false);
        setErrAlert('');
        clear_all_filter();
        setDetailValidation({})
    };

    const validateFields = () => {
        let validationModal = {}
        searchData.accountNumber = searchData.accountNumber?.trim?.()
        setSearchData({ ...searchData });
        if (Helper.valueIsNotNull(searchData.accountNumber) && searchData.accountNumber.length < 2) {
            validationModal.accountNumber = "Enter at least 2 characters without zero";
        }
        if (Helper.valueIsNotNull(searchData.accountName) && searchData.accountName.length < 2) {
            validationModal.accountName = "Please enter at least 2 characters."
        }
        if (searchData.accountNumber?.length > 0 && (!/^(?!0+$)[0-9]+$/.test(searchData.accountNumber))) {
            setErrAlert('Enter keyword greater than zero', 'danger', 'search')
        } else {
            setErrAlert('');
        }

        setDetailValidation(validationModal)
        return Object.keys(validationModal).length > 0 ? false : true;

    }

    return (
        <>
            <div className='bg-grey2 p-3 darkgray-border border-end-0 border-start-0'>
                <div className='row'>
                    <div className='col-md-12 d-flex'>
                        <h5 className='text-darkgreen mt-0 font-arial me-2'><strong>Search for Account</strong></h5>
                        <Tooltip
                            position={'bottom center'}
                            opener={() => (<i className="fa fa-info-circle me-1 font-13 text-black-stone font-16" />)}
                            content={() => 'Account Number or Account Name is Mandatory to Perform Account Search'}
                        />
                    </div>
                    <div className='col-md-3 mb-3'>
                        <label htmlFor="accountNumber">Account Number </label>
                        <input className={"ps-2 form-control form-control-sm mb-0 " + (detailValidation?.accountNumber && "border border-danger")}
                            name="accountNumber"
                            placeholder="Account Number"
                            type="text"
                            value={searchData.accountNumber}
                            onChange={handleInputChange}
                            onBlur={validateFields}
                        />
                        {detailValidation?.accountNumber &&
                            <p className="text-red">{detailValidation.accountNumber}</p>}
                    </div>
                    <div className='col-md-3 mb-3'>
                        <label htmlFor="accountName">Account Name* </label>
                        <input className={"ps-2 form-control form-control-sm mb-0 " + (detailValidation?.accountName && "border border-danger")}
                            name="accountName"
                            placeholder="Account Name"
                            type="text"
                            value={searchData.accountName}
                            onChange={handleInputChange}
                            onBlur={validateFields}
                        />
                        {detailValidation?.accountName && <p className="text-red">
                            {detailValidation.accountName}
                        </p>}

                    </div>
                    <div className='col-md-3 mb-3 multiselect'>
                        <label>Speedboat*</label>
                        <ReactMultiSelectCheckboxes
                            id="speedboat"
                            name="speedboat"
                            placeholder={"Select Speedboat"}
                            value={searchData.speedboat}
                            onChange={(selectedOptions) => {
                                handleInputChange({ target: { name: 'speedboat', value: selectedOptions } })
                            }}
                            options={Constants.speedBoatList}
                            hideSearch={true}
                        />
                    </div>
                    <div className='col-md-3 mb-3 multiselect'>
                        <label>Sales Org</label>

                        <ReactMultiSelectCheckboxes
                            placeholder={"Select Sales Org"}
                            value={searchData.salesOrg}
                            options={(orgList && orgList.length > 0) ? orgList.map(v => ({ label: v, value: v })) : []}
                            onChange={(option) => {
                                handleInputChange({ target: { name: 'salesOrg', value: option } })
                            }} />

                    </div>
                </div>
                <div className="row bs5 mt-2">
                    <div className="col-12 text-sm-end">
                        <button className="bs5 btn btn-secondary me-2" onClick={() => onClear()}>Clear</button>
                        <button className="btn btn-primary bs5" disabled={disableSearch} onClick={(e) => onSearch(e)} >Search</button>
                    </div>
                </div>
            </div>

        </>
    )
}

export default UserSearchAcct;